/** USD con exactamente 2 decimales (montos de costos de notificaciones en el admin). */
export function formatUsd(n: number): string {
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
